import { Duration } from "tinyduration";

import { NumberInput } from "../../../components/ui-kit/fields/number-input";
import { DurationLike } from "./duration-utils";

type DurationUnit = "years" | "months" | "days" | "hours" | "minutes";

const unitLabels: Record<DurationUnit, string> = {
  years: "y",
  months: "mo",
  days: "d",
  hours: "h",
  minutes: "min",
};

const defaultUnits: DurationUnit[] = ["days", "hours", "minutes"];

export function DurationEditor({
  value,
  onChange,
  units = defaultUnits,
}: {
  value: DurationLike | null | undefined;
  onChange: (d: Duration | null) => void;
  units?: DurationUnit[];
}) {
  const d = value ?? {};
  const update = (unit: DurationUnit, v: number | undefined) => {
    const next = { ...d, [unit]: v };
    const isEmpty = units.every((u) => next[u] == null || next[u] === 0);
    onChange(isEmpty ? null : (next as Duration));
  };

  return (
    <div className="flex items-center gap-2 text-sm">
      {units.map((unit) => (
        <div key={unit} className="flex items-center gap-1">
          <NumberInput
            value={d[unit] ?? undefined}
            onChange={(v) => update(unit, v)}
            width={50}
            min={0}
            step={1}
          />
          <span className="whitespace-nowrap">{unitLabels[unit]}</span>
        </div>
      ))}
    </div>
  );
}
